module.exports = __webpack_public_path__ + "static/media/closeX.a80a9a8f.png";